import { render, staticRenderFns } from "./NFSeModalSend.vue?vue&type=template&id=0b4851f8&scoped=true&"
import script from "./NFSeModalSend.vue?vue&type=script&lang=ts&"
export * from "./NFSeModalSend.vue?vue&type=script&lang=ts&"
import style0 from "./NFSeModalSend.vue?vue&type=style&index=0&id=0b4851f8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4851f8",
  null
  
)

export default component.exports